{
  "AppMenu_AppsTitle": "Menu",
  "AppMenu_Apps_Reporting": "Analytics",
  "AppMenu_Apps_FastProvisioning": "Fast Provisioning",
  "AppMenu_Apps_Administration": "Administration",
  "AppMenu_Apps_StatusAndTools": "Status & Tools",
  "AppMenu_FavouritesTitle": "Favorites",
  "AppMenu_NewUI": "CX Suite",
  "AppMenu_ClassicUI": "Classic Look",
  "AppMenu_NewUIBadge": "New",
  "AppMenu_NewUIInvite_AriaLabel": "Try CX Suite",
  "AppMenu_NewUIInvite_Heading": "Check out CX Suite",
  "AppMenu_NewUIInvite_Body": "A faster homepage, roomier reports, and clearer navigation. Give it a try — you can switch back any time.",
  "AppMenu_NewUIInvite_Confirm": "Check it out",
  "AppMenu_NewUIInvite_Dismiss": "Not now",
  "NAME": "AppMenu"
}
